export const ipTransit = {
  title: 'IP Transit',
  subtitle: 'Connettività Internet di qualità con protezione DDoS',
  features: {
    network: {
      title: 'Rete Globale',
      description: 'Connessioni dirette con i principali carrier'
    },
    protection: {
      title: 'Protezione DDoS',
      description: 'Protezione opzionale fino a 4 Tbps'
    },
    capacity: {
      title: 'Alta Capacità',
      description: 'Fino a 10G di banda'
    }
  },
  specs: {
    title: 'Specifiche Tecniche',
    items: [
      'Capacità massima: 10G',
      'Contattaci per preventivi personalizzati',
      'BGP Full Routes'
    ],
    benefitsList: [
      'Latenza minima garantita',
      'Supporto tecnico 24/7',
      'Soluzioni personalizzate per le tue esigenze'
    ]
  }
};